import { IPage } from "data/contentData/interfaces/mongodb/IPage"

/**
 * Checks if the page is a microsite
 * @param page - The page to check if it is a microsite
 * @returns true if the page is a microsite, false otherwise
 * @description This function checks if the page is a microsite by checking if any of its parents are of type CMTopic.
 */
export default function checkIsMicrosite(page: IPage) {
    if (page.types.some(x => x === "CMTopic") || page.parents?.some(parent => parent.types.some(x => x === "CMTopic")))
        return true

    return false
}